module.exports = __webpack_public_path__ + "img/cges-icons.5dd0eb88.svg";